/*
app.configuration.service.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/services/app.configuration.service',[
    'angular',
    '../module'
], function(angular, module) {
    'use strict';

    module.service('appConfigurationService', ['$http', '$q', '$log', '$window', function($http, $q, $log, $window) {
        var CONFIGUARATION_API_URI = '/configuration',
            defaultConfiguration = {
                CASE_SUMMARY_AUTO_REFRESH_DURATION: 30000
            };

        var configurationPromise = null;

        var readConfigurationFromServer = function() {
            var d = $q.defer();
            $http.get(JSON.parse($window.sessionStorage.getItem('X-Endpoints')).apiGatewayUrl + CONFIGUARATION_API_URI, {
                    cache: true
                })
                .then(function(response) {
                    d.resolve(response.data);
                }, function() {
                    $log.error('Unable to read configuration.');
                    d.reject(defaultConfiguration);
                });

            return d.promise;
        };

        var getFromCache = function() {
            var tempConfPromise = configurationPromise;
            if (tempConfPromise) {
                return tempConfPromise;
            }

            tempConfPromise = readConfigurationFromServer();
            tempConfPromise.then(function() {
                configurationPromise = tempConfPromise;
            });

            return tempConfPromise;
        };

        return {
            get: getFromCache
        };
    }]);

    return module;
});

